import axios from 'axios';
import router from '../router';

const state = {
// users state
  locations: []
};

const mutations = {
// users mutations
    SET_LOCATIONS(state, locations) {
        state.locations = locations;
    }
};

const actions = {
  async fetchLocations({ commit }, { search }) {
    const userToken = localStorage.getItem('userToken');
    if (!userToken) {
        throw new Error('No token found'); // Handle absence of token
    }
    
    try {
        const baseUrl = process.env.VUE_APP_API_BASE_URL || 'http://localhost:3000/api';
        const response = await axios.get(`${baseUrl}/locations`, {
            headers: { Authorization: `Bearer ${userToken}` },
            params: { search } // Include search parameter in request
        });
        commit('SET_LOCATIONS', response.data); // Update Vuex store with users
    } catch (error) {
        console.error('Error fetching locations:', error); // Log any errors
        throw error; // Handle error in your components
    }
  },
  async getLocationByID({ commit }, locationId) { // Change from destructuring to direct variable
    console.log('Fetching location with ID:', locationId);
    const userToken = localStorage.getItem('userToken'); 
    if (!userToken) {
        router.push({ name: 'login' });
        return;
    }

    try {
        const baseUrl = process.env.VUE_APP_API_BASE_URL || 'http://localhost:3000/api';
        const response = await axios.get(`${baseUrl}/locations/${locationId}`, {
            headers: { Authorization: `Bearer ${userToken}` }
        });
        console.log('Location fetch response:', response.data);
        commit('SET_LOCATIONS', response.data);
    } catch (error) {
        console.error('Error fetching location:', error);
        throw error;
    }
  },
  async createLocation({ dispatch }, { location }) {
    const userToken = localStorage.getItem('userToken');
    if (!userToken) {
      router.push({ name: 'login' });
      return;
    }
  
    try {
      const baseUrl = process.env.VUE_APP_API_BASE_URL || 'http://localhost:3000/api';
      await axios.post(`${baseUrl}/locations`, location, {
        headers: { Authorization: `Bearer ${userToken}` }
      });
      console.log('Location created:', location);
      dispatch('fetchLocations', { search: '' });
    } catch (error) {
      console.error('Error creating location:', location);
      throw error; // rethrow for component to handle
    }
  },
  async updateLocation({ dispatch }, { location }) {
    console.log('Updating location:', location);
    const userToken = localStorage.getItem('userToken');
    if (!userToken) {
      router.push({ name: 'login' });
      return;
    }
  
    try {
      const baseUrl = process.env.VUE_APP_API_BASE_URL || 'http://localhost:3000/api';
        await axios.put(`${baseUrl}/locations/${location.id}`, location,
          { headers: { Authorization: `Bearer ${userToken}` } }
        );
        console.log('Location updated:', location);
        dispatch('fetchLocations', { search: '' });
      } catch (error) {
        console.error('Error updating location:', location);
        throw error;
      }
  },
  async deleteLocation({ dispatch }, { location }) {
    console.log('Deleting location:', location);
    const userToken = localStorage.getItem('userToken');
    console.log('User token:', userToken);
    if (!userToken) {
      router.push({ name: 'login' });
      return;
    }
  
    try {
      console.log('Location ID:', location.id);
      const baseUrl = process.env.VUE_APP_API_BASE_URL || 'http://localhost:3000/api';
      await axios.delete(`${baseUrl}/locations/${location.id}`,
        { headers: { Authorization: `Bearer ${userToken}` } }
      );
      console.log('Location deleted:', location.id);
      dispatch('fetchLocations', { search: '' });
    } catch (error) {
      console.error('Error deleting location:', error);
      throw error;
    }
  }  
};

const getters = {
// users getters
};
    
export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};